<!-- eslint-disable ts/ban-ts-comment -->
<script lang="ts" setup>
import fullscreen from 'lightgallery/plugins/fullscreen'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
// @ts-expect-error - lack of types (d.ts) file inside the module
import lightgallery from 'lightgallery/vue/LightGalleryVue.umd.js'
import 'lightgallery/scss/lightgallery.scss'
import 'lightgallery/scss/lg-thumbnail.scss'
import 'lightgallery/scss/lg-zoom.scss'
import 'lightgallery/scss/lg-fullscreen.scss'

const plugins = [lgThumbnail, fullscreen, lgZoom]
</script>

<template>
  <lightgallery
    :settings="{
      speed: 500,
      download: false,
      hideScrollbar: true,
      mousewheel: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      actualSize: false,
      infiniteZoom: true,
      showZoomInOutIcons: true,
      plugins,
      ...(typeof $t === 'function'
        ? {
          strings: {
            closeGallery: $t('gallery.close'),
            toggleMaximize: $t('gallery.toggle-maximize'),
            previousSlide: $t('gallery.previous-slide'),
            nextSlide: $t('gallery.next-slide'),
            download: $t('gallery.download'),
            playVideo: $t('gallery.play-video'),
          },
        }
        : {}),
    }"
  >
    <slot />
  </lightgallery>
</template>

<style lang="scss">
.lg-counter {
  display: inline-flex;
}
</style>
